'use client'

import { useEffect, useRef, VideoHTMLAttributes } from 'react'
import { videoResource } from '../utils'

export function Video(
  props: PropsWithClass<{ onEnded?: () => void; src: Path; replay?: number | boolean }> &
    Partial<Omit<VideoHTMLAttributes<never>, 'src'>>,
) {
  const { onEnded, src, replay, autoPlay = true, playsInline = true, muted = true, controls = false, ...rest } = props
  const videoRef = useRef<HTMLVideoElement>(null)

  useEffect(() => {
    const element = videoRef.current
    if (element && onEnded) {
      element.addEventListener('ended', onEnded)

      return () => {
        element.removeEventListener('ended', onEnded)
      }
    }
  }, [onEnded])

  useEffect(() => {
    if (videoRef.current && replay) {
      videoRef.current.currentTime = 0
      void videoRef.current.play()
    }
  }, [replay])

  return (
    <video
      autoPlay={autoPlay}
      playsInline={playsInline}
      muted={muted}
      controls={controls}
      ref={videoRef}
      src={videoResource(src)}
      {...rest}
    >
      Your browser does not support the video tag.
    </video>
  )
}
